import { PageDataError } from 'src/shared/error';

import type { PsfPromoteOrShareDataQuery } from '../api.graphql';
import type { PsfPromoteOrShareRecruiterQuery } from '../recruiter.graphql';

export type PsfPromoteOrSharePageDataErrorCode =
	| 'psf_promote_or_share_page_data_not_found'
	| 'psf_promote_or_share_page_missing_promotion_stats';
export class PsfPromoteOrSharePageDataError extends PageDataError<PsfPromoteOrSharePageDataErrorCode> {}

export type Recruiter = PsfPromoteOrShareRecruiterQuery['recruiter'];
export type Petition = NonNullable<PsfPromoteOrShareDataQuery['petition']>;
export type Viewer = PsfPromoteOrShareDataQuery['viewer'];
export type Bandits = Petition['bandits'];
export type PromotionStats = NonNullable<Petition['promotionStats']>;

export type FcmValues = {
	chipInAmount: number | undefined;
	joinCommunityFooterConfig:
		| Readonly<{
				custom_promoter_count: number;
				custom_contribution_amount: number;
				custom_additional_signatures: number;
		  }>
		| undefined;
	gradualOpening:
		| {
				traffic_percentage: number;
				safe_listed_user_identifiers?: readonly string[];
				block_listed_user_identifiers?: readonly string[];
		  }
		| undefined;
};

export type HeroFeedItem = NonNullable<PsfPromoteOrShareDataQuery['petition']>['feeds']['heroFeed'][0];

export type PsfPromoteOrSharePageData = {
	petition: Omit<Petition, 'bandits' | 'promotionStats'> & {
		promotionStats: NonNullable<NonNullable<PsfPromoteOrShareDataQuery['petition']>['promotionStats']>;
	};
	recruiter?: Recruiter;
	bandits: {
		[key in keyof Omit<Bandits, 'id'>]: Omit<Bandits[key], 'id' | 'variants'> & {
			overridden: boolean;
		};
	};
	chipInAmount: number;
	chipInAmountLocalized: string;
	joinTheCommunityCustomConfig?: {
		promoterCount: number;
		promoterCountLocalized: string;
		contributionAmount: number;
		contributionAmountLocalized: string;
		additionalSignatures: number;
		additionalSignaturesLocalized: string;
	};
	promotionGoal: number;
	promotionGoalLocalized: string;
};
